import React from "react";
import { FormattedMessage } from "react-intl";

import EmptyData from "../EmptyData";
import InitiativeCard from "./InitiativeCard";

import "./style.scss";

const InitiativesList = ({ initiatives, initiativeStatuses, projectStatuses }) => {
  if (!initiatives?.length > 0)
    return <EmptyData title={<FormattedMessage id="no-data" />} />;

  return (
    <div className="cards-wrapper">
      {initiatives.map((item) => (
        <InitiativeCard data={item} key={item?.ID} statuses={initiativeStatuses} projectStatuses={projectStatuses}/>
      ))}
    </div>
  );
};

export default InitiativesList;
